import React, { useEffect } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
} from '../../../constants/Location';
import { screenType } from '../../../constants/enum';
import MessageList from '../../uiParts/MessageList';
import Sidebar from '../../uiParts/Sidebar';

const styles = {
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
};

const AgentMessageList = (): React.ReactElement => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.agent.messageList');
  }, []);

  return (
    <Typography component="div" sx={styles.mypageWrapper}>
      <Sidebar screenType={screenType.agent} />
      <Typography component="div" sx={{ width: '100%' }}>
        <Typography sx={styles.mypageHeader} component="div">
          <Typography sx={styles.mypageHeaderTitle}>
            {t('message.title')}
          </Typography>
        </Typography>
        <MessageList screen={screenType.agent} />
      </Typography>
    </Typography>
  );
};

export default AgentMessageList;
